import Workspace from 'iam/models/Workspace'
import { PrimeWorkspace } from 'iam/WorkspaceStore'
import { collection } from 'infra/collection'
import { Model } from 'infra/model'
import {
  MessageBankDTO,
  MessageBankReplyDTO,
} from 'messaging/dtos/message-bank'
import { observable, makeObservable } from 'mobx'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { MessageBankReply } from './MessageBankReply'

export class MessageBank extends Model<MessageBankDTO, MessageBank> {
  @observable id = Id.none
  @observable workspace = Workspace.none
  @observable dateCreated = DateZero()
  @observable dateModified = DateZero()

  replies = collection<MessageBankReplyDTO, MessageBankReply>({
    create: () => new MessageBankReply(this),
  })

  constructor(private primeWorkspace: PrimeWorkspace) {
    super()
    makeObservable(this)
  }

  parse(json: Partial<MessageBankDTO>): Partial<MessageBank> {
    this.workspace =
      this.primeWorkspace({ id: json.workspace_id }) || this.workspace

    return {
      id: json.id,
      dateCreated: maybeParseDate(json.date_created),
      dateModified: maybeParseDate(json.date_modified),
    }
  }
}
